import React from 'react';

const RISK_COLOR  = { high: '#E11D48', elevated: '#F59E0B', advisory: '#EAB308' };
const RISK_LABEL  = { high: 'HIGH RISK', elevated: 'ELEVATED', advisory: 'ADVISORY' };
const RISK_BG     = {
  high:     'rgba(225,29,72,0.08)',
  elevated: 'rgba(245,158,11,0.08)',
  advisory: 'rgba(234,179,8,0.06)',
};
const RISK_BORDER = {
  high:     'rgba(225,29,72,0.2)',
  elevated: 'rgba(245,158,11,0.18)',
  advisory: 'rgba(234,179,8,0.15)',
};

function relTime(dateStr) {
  const diff = Date.now() - new Date(dateStr).getTime();
  const h    = Math.floor(diff / 3600000);
  if (h < 1)  return 'just now';
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
}

export default function ZoneCard({ zone, incidents, onViewIncidents }) {
  const color  = RISK_COLOR[zone.risk_level]  || '#8892a5';
  const label  = RISK_LABEL[zone.risk_level]  || zone.risk_level.toUpperCase();
  const bg     = RISK_BG[zone.risk_level]     || 'rgba(136,146,165,0.06)';
  const border = RISK_BORDER[zone.risk_level] || 'rgba(136,146,165,0.15)';

  const cutoff7d   = Date.now() - 7 * 24 * 60 * 60 * 1000;
  const zoneIncs   = (incidents || []).filter(
    i => i.zone_id === zone.id && new Date(i.date).getTime() > cutoff7d
  );
  const lastInc    = zoneIncs[0]; // already sorted newest-first

  return (
    <div style={{
      background: '#111a2e',
      border: `1px solid ${border}`,
      borderTop: `3px solid ${color}`,
      borderRadius: 10,
      padding: '18px 20px',
      display: 'flex', flexDirection: 'column', gap: 10,
    }}>
      {/* Zone name + badge */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 8 }}>
        <div style={{ fontFamily: "'Fraunces', serif", fontSize: 14, fontWeight: 700, color: '#fff', lineHeight: 1.3 }}>
          {zone.name}
        </div>
        <span style={{
          flexShrink: 0,
          fontFamily: "'JetBrains Mono', monospace", fontSize: 11, fontWeight: 700,
          color, background: bg, border: `1px solid ${border}`,
          borderRadius: 4, padding: '3px 8px', letterSpacing: '.8px',
        }}>
          {label}
        </span>
      </div>

      {/* Incident count */}
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
        <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 22, fontWeight: 700, color }}>
          {zoneIncs.length}
        </span>
        <span style={{ fontSize: 12, color: '#8892a5' }}>
          incident{zoneIncs.length !== 1 ? 's' : ''} · last 7 days
        </span>
      </div>

      {/* Last incident */}
      <div style={{ fontSize: 11, color: '#8892a5' }}>
        {lastInc
          ? `Last incident: ${relTime(lastInc.date)}`
          : 'No recent UKMTO incidents'}
      </div>

      {/* Description */}
      <div style={{ fontSize: 16, color: '#b8c2d0', lineHeight: 1.55 }}>
        {zone.description}
      </div>

      {/* Actions */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 4 }}>
        <button
          onClick={() => onViewIncidents(zone.id)}
          style={{
            padding: '8px 14px', background: bg, color,
            border: `1px solid ${border}`, borderRadius: 6,
            fontFamily: "'Figtree', sans-serif", fontSize: 13, fontWeight: 600,
            cursor: 'pointer', textAlign: 'left',
          }}
        >
          View incidents →
        </button>
        <a
          href="/routes"
          style={{
            padding: '8px 14px', background: 'rgba(233,160,32,0.06)', color: '#e9a020',
            border: '1px solid rgba(233,160,32,0.18)', borderRadius: 6,
            fontFamily: "'Figtree', sans-serif", fontSize: 11, fontWeight: 600,
            display: 'block', textDecoration: 'none',
          }}
        >
          Estimate cost in Routes →
        </a>
      </div>
    </div>
  );
}
